// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryLink_container__13bCG","disabled":"PrimaryLink_disabled__2eJ9k"};